import ptMessages from '../locales/pt_PT';
import { thatReturnsTrue } from 'react-scale-text';

const PtLang = {
  messages: {
    ...ptMessages,
  },
  locale: 'pt-PT',
};
export default PtLang;
